import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Search from './pages/Search';
import About from './pages/About';
import Experience from './pages/Experience';
import Projects from './pages/Projects';
import Technology from './pages/Technology';
import Interest from './pages/Interest';
import Hobby from './pages/Hobby';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home lang="en" />} />
        <Route path="/ru" element={<Home lang="ru" />} />
        <Route path="/it" element={<Home lang="it" />} />

        <Route path="/en/search" element={<Search lang="en" />} />
        <Route path="/en/about" element={<About lang="en" />} />
        <Route path="/en/experience" element={<Experience lang="en" />} />
        <Route path="/en/projects" element={<Projects lang="en" />} />
        <Route path="/en/technology" element={<Technology lang="en" />} />
        <Route path="/en/interest" element={<Interest lang="en" />} />
        <Route path="/en/hobby" element={<Hobby lang="en" />} />

        <Route path="/ru/search" element={<Search lang="ru" />} />
        <Route path="/ru/about" element={<About lang="ru" />} />
        <Route path="/ru/experience" element={<Experience lang="ru" />} />
        <Route path="/ru/projects" element={<Projects lang="ru" />} />
        <Route path="/ru/technology" element={<Technology lang="ru" />} />
        <Route path="/ru/interest" element={<Interest lang="ru" />} />
        <Route path="/ru/hobby" element={<Hobby lang="ru" />} />

        <Route path="/it/search" element={<Search lang="it" />} />
        <Route path="/it/about" element={<About lang="it" />} />
        <Route path="/it/experience" element={<Experience lang="it" />} />
        <Route path="/it/projects" element={<Projects lang="it" />} />
        <Route path="/it/technology" element={<Technology lang="it" />} />
        <Route path="/it/interest" element={<Interest lang="it" />} />
        <Route path="/it/hobby" element={<Hobby lang="it" />} />

        <Route path="/fr" element={<Home lang="fr" />} />
        <Route path="/fr/search" element={<Search lang="fr" />} />
        <Route path="/fr/about" element={<About lang="fr" />} />
        <Route path="/fr/experience" element={<Experience lang="fr" />} />
        <Route path="/fr/projects" element={<Projects lang="fr" />} />
        <Route path="/fr/technology" element={<Technology lang="fr" />} />
        <Route path="/fr/interest" element={<Interest lang="fr" />} />
        <Route path="/fr/hobby" element={<Hobby lang="fr" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
